
import {defineComponent, computed, ref, inject} from "vue";

import FormControlQuantity from "@/components/FormControlQuantity.vue";
import {useCart} from "@/store/useCart";
import {CartRow} from "@/models/Cart";
import { mapState, mapActions } from "pinia";

export default defineComponent({
  components: {
    FormControlQuantity
  },
  emits: {
    updateCheckout: () => true
  },
  data() {
    return{
      showPricesAsB2b:false, hidePrices:false
    }
  },
  methods: {
    ...mapActions(useCart, ["load", "removeFromCart"])
  },
  mounted() {
    this.load();
    this.showPricesAsB2b = inject<boolean>("show-prices-as-b2b", false);
    this.hidePrices = inject<boolean>("hide-prices", false);
  },
  setup(props, context) {
    const cart = useCart();
    const items = computed(() => {
      const allItems = cart.items as CartRow[];
      const standardItems = allItems.filter(item => item.productType === "Standard");
      return standardItems;
    });

    let validationMessage = "";

    const onQuantity = async (value: number, partNo: string): Promise<void> => {
      await cart.addToCart(partNo, value, false);
      context.emit("updateCheckout");
    };

    const onRemove = async (partNo: string): Promise<void> => {
      await cart.removeFromCart(partNo);
      context.emit("updateCheckout");
    };

    return {
      items,
      onQuantity,
      onRemove,
      validationMessage
    }
  }
});
